import "./header.scss";
import { html } from "lit";
import ComponentBase from "../../../common-components/component-base";

class ShopHeader extends ComponentBase {
  static get tagName() {
    return "ncx-shop-header";
  }

  protected render(): unknown {
    return html`
      <div class="ncx-shop-header__title">Sagra Fauglis 2025</div>
      <div class="ncx-shop-header__subtitle">powered by inCassa</div>
    `;
  }
}
ShopHeader.Register();
export default ShopHeader;
